// Il separatore fra i giorni di una chat, come lo scrive WhatsApp: «Oggi»,
// «Ieri», il giorno della settimana fino a una settimana fa, poi la data
// («12 settembre», con l'anno se non è quello in corso). Prima ogni fumetto
// ripeteva «03/10 21:12» (richiesta del 04/10/2026).
const GIORNI = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];

const inizioGiorno = data => new Date(data.getFullYear(), data.getMonth(), data.getDate());

export function chiaveGiorno(valore) {
  const data = new Date(valore);
  if (Number.isNaN(data.getTime())) return '';
  return `${data.getFullYear()}-${data.getMonth()}-${data.getDate()}`;
}

export function etichettaGiorno(valore, adesso = new Date()) {
  const data = new Date(valore);
  if (Number.isNaN(data.getTime())) return '';
  const giorni = Math.round((inizioGiorno(adesso) - inizioGiorno(data)) / 86400000);
  if (giorni <= 0) return 'Oggi';
  if (giorni === 1) return 'Ieri';
  if (giorni < 7) return GIORNI[data.getDay()];
  const opzioni = { day: 'numeric', month: 'long', ...(data.getFullYear() !== adesso.getFullYear() ? { year: 'numeric' } : {}) };
  return data.toLocaleDateString('it-IT', opzioni);
}

export function ora(valore) {
  const data = new Date(valore);
  return Number.isNaN(data.getTime()) ? '' : data.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}
